import {Label, InputField, PrimaryButton} from "client/CommonComponents";
import { CONSTANTS } from "client/utils/constants";


const AssetNumber = (props: any) => {
const assetNumberError = props?.assetNumberError
const order = props?.order;
const type = props?.type;
const inputRef=props?.inputRef
const AssetType=props?.AssetType

    return (
        <>
            <Label required data-attribute="AssetNumber_Default_Label">{type == CONSTANTS?.REQUISITION ? "Replaced Asset #" : "Asset #"} </Label>
            <div className={`asset-info-wrapper ${AssetType == CONSTANTS?.REACTIVATION ? 'reactivation' : ''}`}>
                <InputField
                    className={"asset-number-input " + (assetNumberError?.assetError?.length ? "controlValidation" : (order?.assetError?.length && "controlValidation"))}
                    onKeyPress={props?.handleKeyPress}
                    name='asset'
                    value={type == CONSTANTS?.REQUISITION ? order?.asset : order?.assetNumber }
                    onChange={(e: any, item: any) => { props?.handleChanges(e, item) }}
                    inputRef={inputRef}
                 data-attribute="AssetNumber_asset_Input" />
                <PrimaryButton text="Get Asset Info" onClick={props?.handleAssetBtn}  data-attribute="AssetNumber_Default_Button" />
            </div>

            {assetNumberError?.assetError?.length ? <p className='validMessage'>{assetNumberError?.assetError}</p> :  <p className='validMessage'>{order?.assetError}</p> }

        </>)

}

export default AssetNumber;
